import { render, staticRenderFns } from "./LLMCard.vue?vue&type=template&id=2af16bb2&"
import script from "./LLMCard.vue?vue&type=script&lang=js&"
export * from "./LLMCard.vue?vue&type=script&lang=js&"
import style0 from "./LLMCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports